import { render, staticRenderFns } from "./projectListJs.vue?vue&type=template&id=0f27947e&scoped=true"
import script from "./projectListJs.vue?vue&type=script&lang=js"
export * from "./projectListJs.vue?vue&type=script&lang=js"
import style0 from "./projectListJs.vue?vue&type=style&index=0&id=0f27947e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f27947e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f27947e')) {
      api.createRecord('0f27947e', component.options)
    } else {
      api.reload('0f27947e', component.options)
    }
    module.hot.accept("./projectListJs.vue?vue&type=template&id=0f27947e&scoped=true", function () {
      api.rerender('0f27947e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/courseDeclare/projectListJs.vue"
export default component.exports